import React from 'react';

function Tabledata({ column }) {
    return (
        <>
            <tbody>
                {[...Array(10)].map((index = 0) => (
                    <tr className="animate-pulse" key={index}>
                        {column && [...Array(column)].map((index = 0) => (
                            <td key={index} className="text-sm font-light text-[#13365C] p-2.5">
                                <div className="h-7 bg-slate-200 rounded" />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </>
    );
}

export default Tabledata;